// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7949":"f1bbeb5e","8162":"09c3725d","9458":"ee79a9f1"}[chunkId] + ".chunk.css";
};